import * as React from "react";
import { Button } from "@workspace/web-ui/components/button";
// import { Card } from "@workspace/web-ui/components/card";
import { toast } from "sonner";
import { useAuth } from "~/providers/auth.provider";
import { useCreateRegistrationPaymentMutation } from "../api/mutations/consultation";
import { useEncounterIdStore } from "~/features/public/pages/welcome/store/use-encounter-id-store";

export default function ConsultationBooking() {
  const auth = useAuth();
  const {encounterId} = useEncounterIdStore()
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null);
  const { mutate: createRegistrationPayment, isPending: isCreatingPayment } = useCreateRegistrationPaymentMutation();
  
  const handlePayment = () => {
    // Get success and cancel URLs
    const successUrl = `${window.location.origin}/consultations/confirmation`;
    const cancelUrl = `${window.location.origin}/consultations/error`;
    
    createRegistrationPayment({
      name: `${auth?.user?.first_name} ${auth?.user?.last_name}`,
      email: auth?.user?.email,
      phone: auth?.user?.phone_number,
      success_url: successUrl,
      cancel_url: cancelUrl,
      encounter_id: encounterId,
    }, {
      onSuccess: (response) => {
        if (response.success) {
          toast.success("Payment initiated");
          window.location.replace(response.data?.payment_metadata.url || '');
        } else {
          setErrorMessage(response.error || "An error occurred while processing your payment");
        }
      },
      onError: () => {
        setErrorMessage("Failed to connect to payment service");
      }
    });
  };

  return (
    <div className="flex justify-center items-center w-full mb-10 max-w-full">
      <div className="w-full max-w-2xl flex flex-col h-full">
        <div className="px-6 pb-6">
          <h1 className="text-3xl font-semibold text-center text-gray-800 mb-2">
            Complete Your Registration
          </h1>
          <p className="text-center text-gray-600 mb-2">
            One final step to start your personalized weight loss journey
          </p>
          
          {errorMessage && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md text-red-600 text-center">
              {errorMessage}
            </div>
          )}
          
          <div className="bg-[#e6e9eb] shadow-md rounded-[16px] mb-6">
          <div className="rounded-lg p-6">
            <div className="flex flex-col gap-2 w-[90%] mx-auto">
              <h2 className="text-[18px] font-medium text-gray-800 mb-2">
                You will get:
              </h2>
                <div className="text-[#464B55] flex items-center gap-2">
                <span className="h-2 w-2 rounded-full bg-[#464B55] inline-block"></span>
                A review of your medical records by certified consultant. 
                </div>
                <div className="text-[#464B55] flex items-center gap-2">
                <span className="h-2 w-2 rounded-full bg-[#464B55] inline-block"></span>
                A one-time 15-minute consultation with a certified consultant.
                </div>
            </div>
          </div>
          <div className="flex items-center rounded-b-[16px] py-4 px-6 bg-[#dfe2e9] justify-between mb-4">
            <span className="text-lg text-[#464B55]">Payment</span>
            <span className="text-lg font-bold text-gray-900">$50.00</span>
          </div>
          </div>
          <Button 
            onClick={handlePayment}
            disabled={isCreatingPayment}
            className="w-full h-12 bg-[#4272DD] hover:bg-blue-700 text-white font-medium rounded-lg"
          >
            {isCreatingPayment ? "Processing..." : "Make Payment"}
          </Button>
        </div>
      </div>
    </div>
  );
}